import axios from '@/utils/axios'

export const addCasePrecaution = data =>
  axios.post('/crm/CasePrecautions/addCasePrecaution', data)
    .then(res => res)

export const updateCasePrecaution = data =>
  axios.post('/crm/CasePrecautions/updateCasePrecaution', data)
    .then(res => res)

export const getCasePrecautionList = data =>
  axios.post('/crm/CasePrecautions/getCasePrecautionList', data)
    .then(res => res)

    // 治疗记录内容列表
export const caseContentList = data =>
  axios.post('/crm/CasePrecautions/caseContentList', data)
    .then(res => res)

export const miniGoodsList = params => axios({
    method: 'get',
    url: '/admin/Goods/miniGoodsList',
    params
  }).then(res => res.data)
export const miniGoodsCreate = data =>
  axios.post('/admin/Goods/miniGoodsCreate', data)
    .then(res => res)
export const miniGoodsUpdate = data =>
  axios.post('/admin/Goods/miniGoodsUpdate', data)
    .then(res => res)
export const miniGoodsDelete = data =>
  axios.post('/admin/Goods/miniGoodsDelete', data)
    .then(res => res)

export const getGoodList = data => axios({
    method: 'post',
    url: '/crm/goods/getList',
    data
  }).then(res => res.data)
export const miniGoodsInfo = params => axios({
  method: 'get',
  url: '/admin/goods/miniGoodsInfo',
  params
}).then(res => res.data)

// 商品列表
export const goodsList = data => axios({
    method: 'post',
    url: '/admin/goods/index',
    data
  }).then(res => res.data)
// 订单页商品列表
export const goodsList2 = params => axios({
    method: 'get',
    url: '/admin/goods/goodsList',
    params
  }).then(res => res.data)
// 获取商品和服务小项
export const getGoodsAndItem = params => axios({
  method: 'get',
  url: '/admin/goods/getGoodsAndItem',
  params
}).then(res => res.data)

// 商品详情
export const goodsGetail = params => axios({
  method: 'get',
  url: '/admin/goods/detail',
  params
}).then(res => res.data)

// 添加商品
export const createGoods = data =>
  axios.post('/admin/Goods/create', data)
    .then(res => res)
  //   axios.post('/admin/goods/create', data)
  // .then(res => res)
    
// 获取服务小项
export const goodsControls = params => axios({
  method: 'get',
  url: '/admin/goods/getControls',
  params
}).then(res => res.data)


// 编辑商品
export const updateGoods = data =>
    axios.post('/admin/Goods/update', data)
    .then(res => res)
  // axios.post('/admin/goods/update', data)
  //   .then(res => res)

// 商品导出
export const exportGoods = data =>
  axios.post('/admin/goods/export', data)
    .then(res => res)

// 删除商品
export const deleteGoods = data =>
  axios.post('/admin/goods/delete', data)
    .then(res => res)
// 一键认领商品
export const claimGoods = data =>
  axios.post('/admin/Goods/claimGoods', data)
    .then(res => res)
    // 一键认领品项
export const claimProductItem = data =>
  axios.post('/crm/ProductItem/claimProductItem', data)
    .then(res => res)
// 商品分类列表
export const categoryList = params => axios({
  method: 'get',
  url: '/admin/category/index',
  params
}).then(res => res.data)
// 检查商品是否被认领
export const checkGoodsClaim = params => axios({
  method: 'get',
  url: '/admin/Goods/check',
  params
}).then(res => res.data)
// 新增商品分类
export const createCategory = data =>
  axios.post('/admin/category/create', data)
    .then(res => res)

// 商品分类详情
export const categoryDetail = params => axios({
  method: 'get',
  url: '/admin/category/detail',
  params
}).then(res => res.data)

// 更新商品分类
export const updateCategory = data =>
  axios.post('/admin/category/update', data)
    .then(res => res)

// 商品详情
export const pointGoodsList = params => axios({
  method: 'get',
  url: '/mini/CustomerPoint/pointGoodsList',
  params
}).then(res => res)
// 上传积分商品图
export const uploadPointGoodsImage = data =>
  axios.post('/mini/CustomerPoint/uploadPointGoodsImage', data)
    .then(res => res)
// 新增商品分类
export const addPointGoods = data =>
  axios.post('/mini/CustomerPoint/addPointGoods', data)
    .then(res => res)
// 商品详情
export const getPointGoodsDetail = params => axios({
  method: 'get',
  url: '/mini/CustomerPoint/getPointGoodsDetail',
  params
}).then(res => res)
// 编辑
export const editPointGoods = data =>
  axios.post('/mini/CustomerPoint/editPointGoods', data)
    .then(res => res)
// 修改状态
export const pointGoodsStatusUpdate = data =>
  axios.post('/mini/CustomerPoint/pointGoodsStatusUpdate', data)
    .then(res => res)

// 品项分析排名列表
export const goodsRankingList = params => axios({
  method: 'get',
  url: '/admin/goods/goodsRankingList',
  params
}).then(res => res.data)
// 商品列表
export const getGoodsList = params => axios({
  method: 'get',
  url: '/crm/ProductItem/getGoodsList',
  params 
}).then(res => res)
// 店铺列表
export const getShopList = params => axios({
  method: 'get',
  url: '/crm/ProductItem/getShopList',
  params 
}).then(res => res)

// 添加品项
export const addProductItem = data =>
  axios.post('/crm/ProductItem/addProductItem', data)
    .then(res => res)
// 修改品项
export const editProductItem = data =>
  axios.post('/crm/ProductItem/editProductItem', data)
    .then(res => res)

// 品项列表
export const getProductItem = data => axios({
  method: 'post',
  url: '/crm/ProductItem/getProductItem',
  data 
}).then(res => res.data)
// 品项类型列表
export const goodsTypeList = params => axios({
  method: 'get',
  url: '/crm/ProductItemType/getProductType',
  params 
}).then(res => res)
//添加品项分类
export const addProductType = data =>
  axios.post('/crm/ProductItemType/addProductType', data)
   .then(res => res)
// 修改品项分类
export const editProductType = data =>
  axios.post('/crm/ProductItemType/editProductType', data)
   .then(res => res)
// 获取品项类型父级
export const getProductTypeParent = params => axios({
  method: 'get',
  url: '/crm/ProductItemType/getLevelList',
  params 
})

// -----------------------模板记录-------------------------
// 模板记录列表
export const getTemplateList = data => axios({
  method: 'post',
  url: '/crm/ServiceNoteTemp/getList',
  data
}).then(res => res.data)
// 添加模板
export const addTemplate = data =>
  axios.post('crm/ServiceNoteTemp/add', data)
    .then(res => res)
// 编辑模板
export const editTemplate = data =>
  axios.post('/crm/ServiceNoteTemp/update', data)
    .then(res => res)
// 获取默认治疗记录或方案
export const getServiceNote = params =>
  axios.get('/crm/ServiceNoteTemp/getServiceNote', { params })
    .then(res => res.data)

// -----------------------产品列表-------------------------
// 产品列表
export const getMaterialList = data =>
  axios.post('/admin/Custom/getMaterialList', data)
    .then(res => res)
// 添加产品
export const createMaterial = data =>
  axios.post('/admin/Custom/createMateria', data)
    .then(res => res)
// 修改产品状态（上下架）
export const updateMaterialStatus = data =>
  axios.post('/admin/Custom/updateStatus', data)
    .then(res => res)
// 产品列表
export const getProductList = data =>
  axios.post('/admin/Custom/getProductList', data)
    .then(res => res)
// 管的品类列表
export const getTubeList = data =>
  axios.post('/admin/Custom/getTubeList', data)
    .then(res => res)
// 新增产品（按品类组合物料）
export const createProduct = data =>
  axios.post('/admin/Custom/createProduct', data)
    .then(res => res)